import Job from './Job';
import styles from './styles.module.scss';

const OpeningList = props => {
    const {jobs, filters, search} = props || {};
    const filterJobs = () => {
        return jobs.filter(job => {
            const matchesSearch = search === '' || job?.name?.toLowerCase().includes(search.toLowerCase());
            const matchesLocation = filters.location === '' || job?.location?.city === filters.location;
            const matchesDepartment = filters.department === '' || job?.department?.id === filters.department;

            return matchesSearch && matchesLocation && matchesDepartment;
        });
    };

    const renderJobs = () => {
        const filteredJobs = filterJobs();
        return filteredJobs.map((item, index) => (
            <li key={index} className={`${styles.openingList__item} ${index % 2 === 0 ? styles.openingList__even : styles.openingList__odd}`}>
                <Job job={item} />
            </li>
        ));
    };

    return (
        <div className={styles.openingList}>
            <div  className={styles.openingList__header}>
                <div className={`${styles.openingList__col} ${styles.openingList__half}`}>
                    <p>
                        Job Title
                    </p>
                </div>
                <div className={`${styles.openingList__col} ${styles.openingList__quarter}`}>
                    <p>
                        Department
                    </p>
                </div>
                <div className={`${styles.openingList__col} ${styles.openingList__quarter}`}>
                    <p>
                        Location
                    </p>
                </div>
            </div>
            <ul  className={styles.openingList__body}>
                {renderJobs()}
            </ul>
        </div>
    );
}

export default OpeningList;